import { useQuery } from 'react-query';
import { taxonService } from 'services';
import { ServerStateKeysEnum } from '../constants';

export const useFetchTaxonDetails = (slug: string) => {
  return useQuery(
    `${ServerStateKeysEnum.taxonDetails}-${slug}`,
    () => {
      return taxonService.getTaxonDetails(slug);
    },
    {
      staleTime: Infinity,
    }
  );
};
